import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {getFirstAppliedFilter} from '@store/common/selectors';

function hasConflictFilter(globalFilters, filters) {
  return filters.filter(i => i[0].field !== 'event_name').some(filter => {
    return globalFilters.some(globalFilter => {
      return globalFilter[0].field === filter[0].field && globalFilter[0].value !== filter[0].value
    })
  })
}

export function useConflictFilters(filters, callback) {
  const globalFilter = useSelector(getFirstAppliedFilter);
  const hasConflict = hasConflictFilter(globalFilter.rule, filters);

  useEffect(() => {
    if (hasConflict) {
      callback();
    }
  }, [hasConflict, callback])

  return hasConflict;
}
